import { Box, Tab, Tabs, Typography } from "@material-ui/core";
import PropTypes from "prop-types";
import * as React from "react";
import useCashoutRequests from "../../hooks/useCashoutRequests";
import Pendingcashout from "./PendingCashout";
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function CashoutPage() {
  const [value, setValue] = React.useState(0);
  const [pendingC, setPendingC] = React.useState([]);
  const [acceptC, setAcceptC] = React.useState([]);
  const [successC, setSuccessC] = React.useState([]);
  const [change, setChange] = React.useState(true);
  const { loading, error, cashoutList } = useCashoutRequests();

  React.useEffect(() => {
    let pL = [];
    let aL = [];
    let sL = [];

    cashoutList.map((c) => {
      if (c.state === "pending") {
        pL.push(c);
      } else if (c.state === "accepted") {
        aL.push(c);
      } else if (c.state === "success") {
        sL.push(c);
      }
    });

    setPendingC(pL);
    setAcceptC(aL);
    setSuccessC(sL);
  }, [cashoutList]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ width: "100%" }}>
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="basic tabs example"
        >
          <Tab label="Pending" {...a11yProps(0)} />
          <Tab label="Accepted" {...a11yProps(1)} />
          <Tab label="Success" {...a11yProps(2)} />
        </Tabs>
      </Box>
      <TabPanel value={value} index={0}>
        <Pendingcashout
          change={change}
          setChange={setChange}
          loading={loading}
          cashoutList={pendingC}
        />
      </TabPanel>
      <TabPanel value={value} index={1}>
        <Pendingcashout
          change={change}
          setChange={setChange}
          loading={loading}
          cashoutList={acceptC}
        />
      </TabPanel>
      <TabPanel value={value} index={2}>
        <Pendingcashout
          change={change}
          setChange={setChange}
          loading={loading}
          cashoutList={successC}
        />
      </TabPanel>
    </Box>
  );
}
